import { render, staticRenderFns } from "./AccessoryIndex.vue?vue&type=template&id=72c27061&"
import script from "./AccessoryIndex.vue?vue&type=script&lang=js&"
export * from "./AccessoryIndex.vue?vue&type=script&lang=js&"
import style0 from "./AccessoryIndex.vue?vue&type=style&index=0&id=72c27061&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports